/*!
 * @license
 * SPDX-License-Identifier: LicenseRef-cloudEQ-Proprietary
 * Copyright (c) 2026-present cloudEQ Inc. All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL.
 *
 * This source code, including all associated files, documentation, and
 * compiled forms, is the exclusive property of cloudEQ Inc. and is
 * protected by copyright, trade secret, and other intellectual property laws.
 *
 * This software is licensed, not sold, solely for use by authorized
 * licensees under the terms of a written license agreement with
 * cloudEQ Inc. Unless expressly permitted by that agreement, you may not
 * copy, modify, merge, distribute, sublicense, sell, publish, reverse
 * engineer, decompile, disassemble, or create derivative works of this
 * software, in whole or in part, by any means.
 *
 * Access to this file does not grant any license or right to use it.
 * Unauthorized use, reproduction, or disclosure is strictly prohibited and
 * may result in civil and criminal penalties.
 *
 * Contact: legal@cloudeq.com
 */

/**
 * `2026-06-18` → `Jun 18`, with the locale left to the browser.
 *
 * **One copy, because there were three and they disagreed.** The list and
 * archived views each had this exact function; the board card had its own that
 * hard-coded `${day} ${month}` and rendered `18 Jun`. So the same task showed two
 * different dates depending on which view you were looking at, and neither view
 * was wrong on its own — which is why nobody reported it.
 *
 * The locale is `undefined` on purpose: vanilla's `fmtDate` does the same, and
 * pinning `en-GB` here would override the reader's own regardless of where they
 * are. `list-view` reads the Due column and expects `Sep 1`.
 *
 * Parsed as local midnight, never as a bare `new Date(iso)` — that reads the
 * string as UTC and shows the previous day for everybody east of Greenwich,
 * which is where this team is.
 */
export function fmtDate(iso: string): string {
  const d = new Date(`${iso}T00:00:00`);
  return Number.isNaN(d.getTime())
    ? iso
    : d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
